import { makeStyles } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Chat from "../chat/Chat";
import SearchIcon from "@material-ui/icons/Search";
import MoreVertIcon from "@material-ui/icons/MoreVert";

const useStyles = makeStyles((theme) => ({
	chatsList: {
		width: "100%",
		// height: '300px',
		borderRadius: "10px",
		background: "#fff",
		border: "1px solid rgba(144, 25, 25, 0.02)",
		boxShadow: "0px 4px 4px rgba(144, 25, 25, 0.05)",
		overflowY: "auto",
		maxHeight: "100vh",
		position: "relative",
	},
	chatHeader: {
		display: "flex",
		justifyContent: "space-between",
		padding: "20px",
	},
	chatBody: {
		padding: "20px",
	},
	chatHead: {
		padding: "6px",
		fontSize: "22px",
		fontWeight: "bold",
	},
	iconContainer: {
		display: "flex",
	},
	noConvo: {
		position: "absolute",
		fontSize: "1.5rem",
		color: "gray",
		opacity: "0.5",
		top: "50%",
		left: "10%",
	},
}));

const ChatList = ({
	currentUser,
	conversations,
	setCurrentChat,
}) => {
	const classes = useStyles();

	return (
		<>
			<div className={classes.chatsList}>
				<div className={classes.chatHeader}>
					<div className={classes.chatHead}>Chats</div>

					<div className={classes.iconContainer}>
						<div className={classes.search}>
							<div className={classes.searchIcon}>
								<IconButton>
									<SearchIcon />
								</IconButton>
							</div>
						</div>
						<div className={classes.moreOption}>
							<IconButton>
								<MoreVertIcon />
							</IconButton>
						</div>
					</div>
				</div>

				<div className={classes.chatBody}>
					{conversations ? (
						<>
							{conversations.map((chat, idx) => (
								<div
									key={chat._id ? chat._id : idx}
									onClick={() => setCurrentChat(chat)}
								>
									<Chat
										currentUser={currentUser}
										conversation={chat}
									/>
								</div>
							))}
						</>
					) : (
						<span className={classes.noConvo}>No conversation</span>
					)}
				</div>
			</div>
		</>
	);
};

export default ChatList;
